const theme = {
  palette: {
    primary: {
      main: "#5270ff",
    },
  },
}

export default theme
